declare var Highcharts: any;
import {Component, OnInit, Input, OnDestroy, ElementRef, ViewChild} from '@angular/core';
import {DashboardService} from '../../../dashboard/services/dashboard.service';
import {Utils} from '../../Utils';
import {DatePipe} from '@angular/common';


@Component({
  selector: 'app-display-henry-hub',
  templateUrl: './display-henry-hub.component.html'
})
export class DisplayHenryHubComponent implements OnInit {

  @Input() title: string;
  data: any;
  subscription: any;
  theChart: any;
  _chart: any;
  tempYears: any = {}; //holds unique years from data.
  years: any = [];
  seriesArray: any = [];
  mostRecent: any = [];
  plotColorsIndex: number = 0;
  plotColors: any = ['#0096D7', '#BD732A', '#5D9732', '#FFC702', '#A33340', '#DAADB3', '#76D5FF', '#BED5AD', '#006997', '#f27000'];//#8577A2
  @ViewChild('eiaHenryHub') public chartEl: ElementRef;


  constructor(private dashboardService: DashboardService, public datePipe: DatePipe) {
  }

  ngOnInit() {
    const controller = this;
    this.subscription = controller.dashboardService.getHenryHubGasPricesData().subscribe(
      json => {

        // create an string property for each date property in the objects.
        controller.data = json.data.map(function (element) {
          var tempArray = [element.x, element.y];
          tempArray['reportDateString'] = new Date(element.reportDate).getUTCFullYear();
          element.tempArray = tempArray;
          element.reportDateShort = Utils.dateAsMMMDD(new Date(element.reportDate));
          element.reportDateString = new Date(element.reportDate).getUTCFullYear();
          element.storageDateString = Utils.dateAsPlainString(new Date(element.storageDate));
          element.priceDateString = Utils.dateAsPlainString(new Date(element.priceDate));
          return element;
        });

        // get most recent point as its own point for use in its own series
        controller.mostRecent = json.data[json.data.length - 1];
        json.data.pop();


        // get array of unique years in the data
        this.data.forEach(element => {
          if (!controller.tempYears[element.reportDateString]) {
            controller.tempYears[element.reportDateString] = 1;
            controller.years.push(element.reportDateString);
          }
        });

        // build a series object for each unique year in the data
        controller.years.forEach(thing => {
          var tempObject = {};
          tempObject['name'] = thing;
          tempObject['data'] = [];
          tempObject['marker'] = {};
          //todo:set tempObject.marker.fillColor dynamically here
          tempObject['marker'].fillColor = this.plotColors[controller.plotColorsIndex];
          controller.plotColorsIndex++;

          var tempData = controller.data.filter(element => {
            return element.reportDateString == thing;
          });

          //format data as an object with props x, y, reportDate, storageDate, priceDate.
          tempData.forEach(element => {
            tempObject['data'].push({
              x: element.x,
              y: element.y,
              reportDate: element.reportDateString,
              storageDate: element.storageDateString,
              priceDate: element.priceDateString,
              reportDay: Utils.dateAsPlainString(new Date(element.reportDate))
            });
          });

          // numeric sort on x
          tempObject['data'].sort(function (a, b) {
            return a['x'] - b['x'];
          });

          controller.seriesArray.push(tempObject);
        });


        // add most recent point to series array
        const tempMostRecent = {};
        tempMostRecent['name'] = this.datePipe.transform(new Date(controller.mostRecent.reportDate), 'MM/d/yyyy', 'UTC');
        tempMostRecent['data'] = [{
          x: controller.mostRecent.x,
          y: controller.mostRecent.y,
          reportDate: controller.mostRecent.reportDateString,
          storageDate: controller.mostRecent.storageDateString,
          priceDate: controller.mostRecent.priceDateString,
          reportDay: Utils.dateAsPlainString(new Date(controller.mostRecent.reportDate))
        }];
        tempMostRecent['marker'] = {
          radius: 6,
          lineColor: 'rgb(255,255,255)',
          lineWidth: 1,
          fillColor: this.plotColors[this.plotColorsIndex]
        };

        controller.seriesArray.push(tempMostRecent);

        var larrow = {
          name: 'leftArrow',
          color: Highcharts.eia_grey,
          dataLabels: {
            align: 'left',
            enabled: true,
            x: -50,
            y: 6,
            format: 'deficit'
          },
          data: [{
            marker: {
              symbol: 'Larrow'
            },
            y: .5,
            x: -460
          },
            {
              dataLabels: {
                enabled: false
              },
              marker: {
                enabled: false,
                symbol: 'Rarrow'
              },
              y: .5
            }],
          type: 'line',
          lineWidth: 5,
          connectNulls: true,
          showInLegend: false,
          enableMouseTracking: false,
          marker: {
            enabled: true
          }
        };

        var rarrow = {
          name: 'rightArrow',
          color: Highcharts.eia_grey,
          dataLabels: {
            align: 'right',
            enabled: true,
            x: 50,
            y: 6,
            format: 'surplus'
          },
          data: [{
            dataLabels: {
              enabled: false
            },
            marker: {
              enabled: false,
              symbol: 'Larrow'
            }, y: .5
          }, {
            marker: {
              enabled: true,
              symbol: 'Rarrow'
            }, y: .5, x: 500
          }],
          type: 'line',
          lineWidth: 5,
          connectNulls: true,
          showInLegend: false,
          enableMouseTracking: false,
          marker: {
            enabled: true
          }
        };

        controller.seriesArray.push(larrow);
        controller.seriesArray.push(rarrow);
      },
      () => {
      },
      () => {
        this.theChart = {
          chart: {
            type: 'scatter',
            zoomType: 'xy'
          },
          title: {
            text: controller.title
          },
          credits: {
            enabled: false
          },
          logos: {
            none: 0
          },
          xAxis: {
            title: {
              enabled: true,
              text: 'billion cubic feet'
            },
            max: 1500,
            min: -1500,
            tickInterval: 500,
            startOnTick: true,
            endOnTick: true,
            showLastLabel: true
          },
          yAxis: {
            title: {
              text: 'price of gas at the Henry Hub in dollars per million British thermal units',
              margin: 25
            },
            tickInterval: 1

          },
          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
            itemMarginTop: 3,
            itemMarginBottom: 3,
            floating: false,
            y: 10
          },
          tooltip: {
            formatter: function () {
              var formatter = this;
              var defOrSur = formatter.x >= 0?'surplus: ': 'deficit: ';
              var toolTipString = '';
              toolTipString += '<div>' + formatter.point.reportDay + '</div><br>' + defOrSur +  Utils.numberWithComma(formatter.x) + ' Bcf' + '<br>' +
                'price: $' + Math.round(formatter.y * 100) / 100 + '<br>' +
                'storage date: ' + formatter.point.storageDate + '<br>';

              return toolTipString;
            }
          },
          plotOptions: {
            scatter: {
              marker: {
                radius: 4,
                lineColor: 'rgb(255,255,255)',
                lineWidth: 1,
                states: {
                  hover: {
                    enabled: true,
                    lineColor: 'rgb(255,255,255)'
                  }
                }
              },
              states: {
                hover: {
                  marker: {
                    enabled: false
                  }
                }
              },
            }
          },
          series: controller.seriesArray
        };

        this.setupChart();

      });
  }

  private setupChart() {


    Highcharts.wrap(Highcharts.Legend.prototype, 'colorizeItem', function (proceed, item, visible) {
      item.legendColor = item.options.legendColor;
      proceed.apply(this, Array.prototype.slice.call(arguments, 1));
    });


    if (this.chartEl && this.chartEl.nativeElement) {


      this.theChart.chart = {
        logo: Highcharts.logos.none,
        renderTo: this.chartEl.nativeElement,

        type: 'scatter',
        zoomType: 'xy',
        //inverted:false
      };

      // Define a custom symbol path for left arrowhead
      Highcharts.SVGRenderer.prototype.symbols.Larrow = function (x, y, w, h) {
        return ['M', x - 10, (y + 4), 'L', x - 10 + w * 1.75, (y + 4) + h, 'L', x - 10 + w * 1.75, (y + 4) - h, 'z'];
      };


      if (Highcharts.VMLRenderer) {
        Highcharts.VMLRenderer.prototype.symbols.Larrow = Highcharts.SVGRenderer.prototype.symbols.Larrow;
      }

      // Define a custom symbol path for right arrowhead
      Highcharts.SVGRenderer.prototype.symbols.Rarrow = function (x, y, w, h) {
        return ['M', x + 10, (y + 4), 'L', x + 10 - w * 1.75, (y + 4) - h, 'L', x + 10 - w * 1.75, (y + 4) + h, 'z'];
      };
      if (Highcharts.VMLRenderer) {
        Highcharts.VMLRenderer.prototype.symbols.Rarrow = Highcharts.SVGRenderer.prototype.symbols.Rarrow;
      }

      this._chart = new Highcharts.Chart(this.theChart);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/display-henry-hub/display-henry-hub.component.ts